import { useCallback, useRef } from "react"
import type { SourceMetricIdsChangeHandler } from "./use-source-displayed-metric-ids"

export function useDisplayedMetricIds(view: string) {
  const sourcedMetricIdsRef = useRef<{ view: string, metricIds: string[] } | null>(null)

  const handleDisplayedMetricIdsChange = useCallback<SourceMetricIdsChangeHandler>((metricIds) => {
    sourcedMetricIdsRef.current = metricIds?.length ? { view, metricIds } : null
  }, [view])

  return { sourcedMetricIdsRef, handleDisplayedMetricIdsChange }
}
